module.exports = __webpack_public_path__ + "static/media/western-3.66a185c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/western-3.jpg
// module id = 118
// module chunks = 0